// src/pages/Contact.js
import React from 'react';
import Reveal from "../components/Reveal";
import "../styles/Contact.css";
import heroBg from "../assets/contactbanner.jpg"; 

function Contact() {
  return (
    <div className="contact-page">
      <div className="page-header" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="overlay"></div>
        <div className="container header-content">
          <Reveal>
            <h1>Contact Us</h1>
            <p>We'd love to hear from you. Reach out with any questions or inquiries.</p>
          </Reveal>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <Reveal>
            <div className="contact-grid">
              
              <div className="contact-info">
                <h2>Get in Touch</h2>
                <p className="intro-text">
                  Whether you have a question about events, memberships, or just want to say hello, we're here to help.
                </p>
                
                <div className="info-card">
                  <h3>Office</h3>
                  <p>737 Keewatin St,<br/>Winnipeg, MB R2X 3B9</p>
                </div>
                
                <div className="info-card">
                  <h3>Phone</h3>
                  <p><a href="tel:2047754928">(204) 775-4928</a></p>
                </div>

                <div className="info-card">
                  <h3>Email</h3>
                  <p><strong>Office:</strong> <a href="mailto:thenewpccm@gmail.com">thenewpccm@gmail.com</a></p>
                  <p><strong>President:</strong> <a href="mailto:president@thenewpccm.ca">president@thenewpccm.ca</a></p>
                </div>

                <div className="social-connect">
                  <h3>Follow Us</h3>
                  <div className="social-buttons">
                    <a href="https://www.facebook.com/groups/3555107267913403/" target="_blank" rel="noreferrer" className="btn btn-outline" style={{borderColor: 'var(--primary)', color: 'var(--primary)'}}>Facebook</a>
                    <a href="https://thenewpccm.substack.com/" target="_blank" rel="noreferrer" className="btn btn-outline" style={{borderColor: 'var(--primary)', color: 'var(--primary)'}}>Substack</a>
                  </div>
                </div>
              </div>

              <div className="contact-form-wrapper card">
                <iframe 
                  src="https://forms.fillout.com/t/cRYJdhsiY7us" 
                  width="100%" 
                  height="700px" 
                  frameBorder="0" 
                  marginHeight="0" 
                  marginWidth="0" 
                  title="Contact Form"
                >
                  Loading…
                </iframe>
              </div>

            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

export default Contact;
